<div *ngIf="url =='email-otp'">
    <div class="container-fluid col-md-6 mt-2 m-auto">
<form [formGroup]="otpForm" autocomplete="new-form">
  
    <div class="activationCodeContainer"> 
        <h2 class="text-center">Email OTP Verification</h2>
        <br>
        <p class="text-center">Please enter the One-Time Password (OTP) that was sent to your email Address.
        </p>

    <div class="classfifty input-group form-group justify-content-center mt-2">
        <div class="input-group-prepend mb-2 mb-sm-0">
            <span class="input-group-text colordiv"><i class="fa fa-lock lockIcon colordiv"></i></span>
        </div>
        <div class="otp-input-container">
            <div *ngFor="let i of [0, 1, 2, 3, 4, 5]; let index = index" class="otp-input-box">
                <input #otpInput type="tel" minlength="1" maxlength="1" (keypress)="numberOnly($event, index)"
                    (input)="onInputChange($event,'otp' + index)" [id]="'otp' + index"
                    (keydown)="onBackspaceKeyDown($event, index)" [formControlName]="'otp' + index"
                    (keyup)="onOtpInput(index)">
            </div>
        </div>
    </div>
    <br>
    <div *ngIf="control['otp'].errors && submitted" class="text-center">
        <div *ngIf="control['otp'].errors['required']" class="text-danger letterspacing">
            {{'OTP_is_required'|translate}}</div>
    </div>
    <div>
      <p class="text-center my-2"  *ngIf="showResendButton==true">
        {{ 'If you do not receive OTP' | translate }} <a href="javascript:void(0)" (click)="resendOTP()">Resend
          OTP</a>
      </p>
      <p class="text-center my-2"  *ngIf="showResendButton==false">You can resend OTP request again in</p>
      <div class="load" *ngIf="showResendButton==false">
        <div class="progress-time mx-4" [style.--progress-value]="timeRemaining_percent">
          <progress style="visibility:hidden;height:0;width:0;"></progress>
          <span class="progress-value">{{remainingTime}}</span>
        </div>
      </div>

    </div>
    <br>
    <div class="col-md-12 my-2 text-center">
        <button type="submit" class="btn btn-success" (click)="validateOtp()" ><em
            class="fa fa-arrow-right fa-fw"></em>Verify OTP</button>
      </div>
    </div>
    
   
    </form>
</div>
</div>

<div *ngIf="url ==='reset-password'">
<div  class="container-fluid  mt-2 m-auto">
    <div class="text-center my-4">
      <p class="text-center">You can now proceed to set your password. Choose a strong and unique password to ensure the security of your account
      </p>
    </div>
  
    <div class="col-md-6 m-auto">
      <form [formGroup]="passwordForm" autocomplete="off" class="row mt-1"> 
        <div class="activationCodeContainer">
          <div class="col-md-12 mb-2">
            <label class="formLabel font-weight-bold" for="newpassword">{{'New_PassWord'|translate}}<span
                class="text-danger">*</span></label>
            <input type="password" formControlName="newpassword"
              [ngClass]="{'is-invalid': passwordForm.get('newpassword')?.invalid && (passwordForm.get('newpassword')?.dirty || passwordForm.get('newpassword')?.touched),
                'is-valid': passwordForm.get('newpassword')?.valid && (passwordForm.get('newpassword')?.dirty || passwordForm.get('newpassword')?.touched)}"
              name="newpassword" id="newpassword" class="form-control" autocomplete="new-password">
  
            <div class="invalid-feedback"
              *ngIf="passwordForm.get('newpassword')?.invalid && (passwordForm.get('newpassword')?.dirty || passwordForm.get('newpassword')?.touched)">
              <div *ngIf="passwordForm.get('newpassword')?.errors?.['required']">{{'new_password_required'|translate}}
              </div>
              <div *ngIf="passwordForm.get('newpassword')?.errors?.['pattern']">{{'password_error_message'|translate}}
              </div>
            </div>
          </div>
          <br>
          <div class="col-md-12 mb-2">
            <label class="formLabel font-weight-bold" for="newpassword">{{'Confirm_New_PassWord'|translate}}<span
                class="text-danger">*</span></label>
            <input type="password" formControlName="connewpassword"
              [ngClass]="{'is-invalid': passwordForm.get('connewpassword')?.invalid && (passwordForm.get('connewpassword')?.dirty || passwordForm.get('connewpassword')?.touched),
                'is-valid': passwordForm.get('connewpassword')?.valid && (passwordForm.get('connewpassword')?.dirty || passwordForm.get('connewpassword')?.touched)}"
              name="connewpassword" id="connewpassword" class="form-control" autocomplete="off">
            <div class="invalid-feedback"
              *ngIf="passwordForm.get('connewpassword')?.invalid && (passwordForm.get('connewpassword')?.dirty || passwordForm.get('connewpassword')?.touched)">
              <div *ngIf="passwordForm.get('connewpassword')?.errors?.['required']">{{'new_password_required'|translate}}
              </div>
              <div *ngIf="passwordForm.get('connewpassword')?.errors?.['mustMatch']">{{'pass_match'|translate}}</div>
              <div *ngIf="passwordForm.get('connewpassword')?.errors?.['pattern']">{{'password_error_message'|translate}}
              </div>
            </div>
          </div>
        </div>
  
  
        <div class="col-12 text-center mt-2">
          <button type="submit" class="btn btn-success me-1" (click)="updateResetPwd()">
            <em class="fa fa-check fa-fw"></em> Reset Password
          </button>
        </div>
  
      </form>
  
    </div>
  
  </div>
  </div>